<!-- @format -->

<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<!-- @format -->
@let brandFilteredList = filter.valueList | filterBy: 'value' : brandFilterString;

@if (
	!isRatingsFilter &&
	(!isCategoryFilter || (productListSEOData$ | async) === null || isPlp3Template)
) {
	<homefield-accordion
		class="homefield-accordion"
		width="100%"
		collapsedHeight="56px"
		[header]="filter.attrName === GTGT_FILTER_NAME ? GTGT_TITLE : filter.attrName"
		[subHeader]="selectedSubheaders"
		[isInline]="true"
		[topBorder]="false"
		[isDarkVariant]="false"
		(focused)="onAccordionFocus()"
		[isExpanded]="defaultOpen"
		(isExpandedChange)="toggleFacet($event)">
		<div
			id="filter-wrapper"
			class="hmf-pb-s hmf-pl-xs hmf-pr-s"
			ngProjectAs="customAccordionContent">
			<!-- BBRAND FILTER -->
			@if (isBrandFilter) {
				@if (filter.valueList?.length > 10) {
					<div class="brand-input-container hmf-mb-s">
						<!-- SEARCH BAR FOR BRAND -->
						<hmf-text-input
							type="text"
							class="search-brands-input"
							placeholder="Search Brands"
							inputStartIconName="search"
							label="Search Brands"
							[disabled]="disabled"
							[(ngModel)]="brandFilterString"
							(input)="brandInputChanged()"></hmf-text-input>
					</div>
				}
				<div
					#scrollableParent
					class="checkbox-container hmf-position-relative hmf-pr-xxs"
					[class]="{
						'view-more': featureFlags().viewMoreEnabled && !showMore,
						'view-less': featureFlags().viewMoreEnabled && showMore
					}"
					[ngStyle]="{ 'max-height': !featureFlags().viewMoreEnabled ? filterHeight : '' }">
					@if (
						(!brandFilterString && featureFlags().viewMoreEnabled) ||
						(!featureFlags().viewMoreEnabled && !showMore)
					) {
						<!-- Remove 'Top Brands' for brands 10 and less and sort in alphabetically -->
						<!-- Brands return alphabetically from api -->
						@if (filter.valueList?.length > 10) {
							<div
								id="top-filters"
								class="hmf-mb-xxs hmf-body-bold-m">
								Top Brands
							</div>
						}
						@for (
							filterOption of filter.valueList?.length > 10
								? (filter.valueList | orderBy: 'count' | slice: 0 : 10)
								: filter.valueList;
							track trackFilterName(i, filterOption);
							let i = $index
						) {
							<div
								id="{{
									isMobile
										? 'filter-mobile-' + filterOption.value
										: 'filter-' + filterOption.value
								}}"
								class="single-filter hmf-body-m hmf-align-items-center hmf-mb-xxs">
								<hmf-checkbox
									class="filter-name hmf-mr-0 hmf-mb-0"
									[id]="filter.attrIdentifier + '-' + filterOption.value"
									[disabled]="disabled"
									[checked]="
										selectedOptions.includes(filterOption.value) ? true : null
									"
									[ariaLabel]="
										filterOption.value +
										', ' +
										filterOption.count +
										' ' +
										'products'
									"
									(eventChange)="setSelectedFilter(filterOption.value)">
								</hmf-checkbox>
								<div
									class="filter-value-count-container hmf-display-flex hmf-justify-content-between hmf-align-items-center"
									[attr.aria-hidden]="true"
									(click)="setSelectedFilter(filterOption.value)">
									{{ filterOption.value }}
									<div>({{ filterOption.count }})</div>
								</div>
							</div>
						}
					}
					@if (showMore || (featureFlags().viewMoreEnabled && hasOverflow)) {
						@for (
							filterOption of brandFilteredList;
							track trackFilterName(i, filterOption);
							let i = $index
						) {
							<!-- Check if the first letter of the current brand matches the first letter of the brand before it, and if not display the letter as a title -->
							<!-- Brands return alphabetically from api -->
							@if (
								(i === 0 ||
									brandFilteredList[i - 1].value[0].toLowerCase() !==
										filterOption.value[0].toLowerCase()) &&
								regexForLettersOnly.test(filterOption.value[0])
							) {
								<div
									class="hmf-ml-xxxs hmf-mb-xxs alpha-sub-header-text hmf-subheader-bold-s">
									{{ filterOption.value[0].toUpperCase() }}
								</div>
							}
							@if (
								i === 0 &&
								!regexForLettersOnly.test(filterOption.value[0]) &&
								featureFlags().viewMoreEnabled
							) {
								<div
									class="hmf-ml-xxxs hmf-mb-xxs alpha-sub-header-text hmf-subheader-bold-s">
									#
								</div>
							}
							<div
								id="{{
									isMobile
										? 'filter-mobile-' + filterOption.value
										: 'filter-' + filterOption.value
								}}"
								class="single-filter hmf-body-m hmf-align-items-center hmf-mb-xxs">
								<hmf-checkbox
									class="filter-name hmf-mr-0 hmf-mb-0"
									[id]="filter.attrIdentifier + '-' + filterOption.value"
									[disabled]="disabled"
									[checked]="
										selectedOptions.includes(filterOption.value) ? true : null
									"
									[ariaLabel]="
										filterOption.value +
										', ' +
										filterOption.count +
										' ' +
										'products'
									"
									(eventChange)="setSelectedFilter(filterOption.value)">
								</hmf-checkbox>
								<div
									class="filter-value-count-container hmf-display-flex hmf-justify-content-between hmf-align-items-center"
									(click)="setSelectedFilter(filterOption.value)">
									{{ filterOption.value }}
									<div>({{ filterOption.count }})</div>
								</div>
							</div>
						}
					}
				</div>
				@if (hasOverflow && featureFlags().viewMoreEnabled && !brandFilterString) {
					<button hmf-action-text
							variant="secondary"
							[class]="!showMore ? '' : 'hmf-pt-s'"
							(click)="toggleShowMore()">
						{{ !showMore ? 'View All Brands +' : 'View Less' }}
					</button>
				}
				@if (hasOverflow && !featureFlags().viewMoreEnabled && !showMore) {
					<button hmf-action-text
							variant="secondary"
							(click)="toggleShowMore()">
						See All Filters+
					</button>
				}
			}
			@if (!isBrandFilter && !isSizeFilter && (!isPlp3Template || !isCategoryFilter)) {
				<!-- NON BRAND FILTERS -->
				<div
					#scrollableParent
					class="checkbox-container hmf-position-relative hmf-pr-xxs"
					[class]="
						featureFlags().viewMoreEnabled
							? !showMore
								? 'view-more no-unique-height'
								: 'view-less no-unique-height'
							: ''
					"
					[ngStyle]="{ 'max-height': !featureFlags().viewMoreEnabled ? filterHeight : '' }">
					@for (
						filterOption of filteredList;
						let isFirst = $first;
						track trackFilterName($index, filterOption)
					) {
						@if (
							!(filter.attrName === GTGT_FILTER_NAME && filterOption.value === 'N')
						) {
							<div
								id="{{
									isMobile
										? 'filter-mobile-' + filterOption.value
										: 'filter-' + filterOption.value
								}}"
								class="single-filter hmf-align-items-center hmf-body-m hmf-mb-xxs">
								@if (!isCategoryFilter) {
									<hmf-checkbox
										class="filter-name hmf-mr-0 hmf-mb-0"
										[id]="filter.attrIdentifier + '-' + filterOption.value"
										[disabled]="disabled"
										[checked]="
											selectedOptions.includes(filterOption.value)
												? true
												: null
										"
										[ariaLabel]="
											isPriceFilter || filter.attrName === GTGT_FILTER_NAME
												? displayText[filterOption.value]
												: filterOption.value +
													', ' +
													filterOption.count +
													' ' +
													'products'
										"
										(eventChange)="setSelectedFilter(filterOption.value)">
									</hmf-checkbox>
								}
								<div
									class="filter-value-count-container hmf-display-flex hmf-justify-content-between hmf-align-items-center"
									[class]="{
										'hmf-ml-xxxs': isCategoryFilter,
										'hmf-mt-xxxs': isFirst && isCategoryFilter
									}"
									[attr.role]="isCategoryFilter ? 'link' : null"
									[attr.tabindex]="isCategoryFilter ? 0 : null"
									[attr.aria-label]="
                                        isCategoryFilter ?
                                            `${categoryDetails[filterOption.value]?.name}. ${filterOption.count} products. ${selectedOptions.includes(filterOption.value) ? 'selected' : 'not selected'}`
                                        : null"
									(keydown.space)="
										setSelectedFilterWithSpace($event, filterOption.value)
									"
									(click)="setSelectedFilter(filterOption.value)">
									@if (filter.attrName === 'Color') {
										<div class="hmf-display-flex hmf-align-items-center">
											<homefield-color-swatch
												radius="50%"
												class="hmf-ml-xxxs hmf-display-flex"
												height="16px"
												width="16px"
												[tabIndex]="-1"
												[color]="filterOption.value"
												[filterColorSwatchHoverDimension]="true"
												[colorSwatchHoverDimension]="true"
												[imageSrc]="
													filterOption.value === 'Multi'
														? MULTICOLOR_IMAGE
														: undefined
												"
												[selected]="
													selectedOptions.includes(filterOption.value)
												">
											</homefield-color-swatch>
											{{ filterOption.value }}
										</div>
									} @else {
										<span>
											{{
												isPriceFilter ||
												filter.attrName === GTGT_FILTER_NAME
													? displayText[filterOption.value]
													: isCategoryFilter
														? categoryDetails[filterOption.value]?.name
														: filterOption.value
											}}
										</span>
									}
									@if (
										!(
											filter.attrName === GTGT_FILTER_NAME &&
											filterOption.value === 'N'
										)
									) {
										<div>({{ filterOption.count }})</div>
									}
								</div>
							</div>
						}
					}
				</div>
			}
			@if (isCategoryFilter && isPlp3Template) {
				<!-- PLP3 Template Category Filter -->
				<div
					#scrollableParent
					class="checkbox-container hmf-position-relative hmf-pr-xxs"
					[class]="
						featureFlags().viewMoreEnabled
							? !showMore
								? 'view-more no-unique-height'
								: 'view-less no-unique-height'
							: ''
					"
					[ngStyle]="{ 'max-height': !featureFlags().viewMoreEnabled ? filterHeight : '' }">
					@for (
						filterOption of filteredList;
						track trackFilterName($index, filterOption)
					) {
						<a
							id="{{
								isMobile
									? 'filter-mobile-' + filterOption.value
									: 'filter-' + filterOption.value
							}}"
							class="single-filter hmf-mb-s hmf-body-m"
							tabindex="{{ defaultOpen ? 0 : -1 }}"
							[href]="categoryDetails[filterOption.value]?.url">
							<div class="hmf-display-flex hmf-align-items-center">
								<span>
									{{ categoryDetails[filterOption.value]?.name }}
								</span>
							</div>
						</a>
					}
				</div>
			}
			@if (isSizeFilter) {
				<div
					#scrollableParent
					class="checkbox-container size-filter-wrapper hmf-position-relative hmf-display-flex hmf-justify-content-start hmf-flex-wrap"
					[class]="
						featureFlags().viewMoreEnabled
							? !showMore
								? 'view-more hmf-mb-xs'
								: 'view-less'
							: ''
					"
					[ngStyle]="{ 'max-height': !featureFlags().viewMoreEnabled ? filterHeight : '' }">
					@for (
						filterOption of filteredList;
						track trackFilterName($index, filterOption)
					) {
						<button
							id="{{
								isMobile
									? 'filter-mobile-' + filterOption.value
									: 'filter-' + filterOption.value
							}}"
							class="size-filter hmf-display-flex hmf-justify-content-between hmf-py-xs hmf-px-s"
							tabindex="{{ defaultOpen ? 0 : -1 }}"
							[class]="{ selected: selectedOptions.includes(filterOption.value) }"
							[attr.aria-label]="
								filterOption.value +
								', ' +
								filterOption.count +
								' ' +
								'products' +
								', ' +
								(selectedOptions.includes(filterOption.value)
									? 'selected'
									: 'not selected')
							"
							(click)="setSelectedFilter(filterOption.value)">
							<span class="size-filter-label">{{ filterOption.value }}</span>
							<span>({{ filterOption.count }})</span>
						</button>
					}
				</div>
			}
			@if (hasOverflow && !isBrandFilter && featureFlags().viewMoreEnabled) {
				<button hmf-action-text
						variant="secondary"
						tabindex="{{ defaultOpen ? 0 : -1 }}"
						[ngClass]="{ 'hmf-pt-s': showMore, 'hmf-px-0': isCategoryFilter }"
						(click)="toggleShowMore()">
					{{ !showMore ? 'View More' : 'View Less' }}
				</button>
			}
		</div>
	</homefield-accordion>
}
